import React from 'react';
import { HoverCard as RadixHoverCard } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * HoverCard components - wrappers around Radix UI HoverCard
 * Provides all functionality of the original components while allowing
 * for centralized customization and future extensions.
 */

export type HoverCardRootProps = RadixComponentProps<
  typeof RadixHoverCard.Root
>;
export type HoverCardTriggerProps = RadixComponentProps<
  typeof RadixHoverCard.Trigger
>;
export type HoverCardContentProps = RadixComponentProps<
  typeof RadixHoverCard.Content
>;

const HoverCardRoot: React.FC<HoverCardRootProps> = props => {
  return <RadixHoverCard.Root {...props} />;
};

const HoverCardTrigger: React.FC<HoverCardTriggerProps> = props => {
  return <RadixHoverCard.Trigger {...props} />;
};

const HoverCardContent: React.FC<HoverCardContentProps> = props => {
  return <RadixHoverCard.Content {...props} />;
};

HoverCardRoot.displayName = 'HoverCardRoot';
HoverCardTrigger.displayName = 'HoverCardTrigger';
HoverCardContent.displayName = 'HoverCardContent';

export { HoverCardRoot, HoverCardTrigger, HoverCardContent };
